import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Paper,
  makeStyles,
} from "@material-ui/core";
import { useDispatch, useSelector } from "react-redux";
import BreadCrum from "../BreadCrum/BreadCrum";
import TableCollapsible from "../TableCollapsible/index";
import {
  GetOrderAction,
  UpdateOrderStatus,
  UpdateOrderItemStatus,
} from "../../reduxState/aciton/orderAction";
import OrderSearch from "./searchInput";

const useStyles = makeStyles((theme) => ({
  root: { padding: theme.spacing(2), minWidth: 0 },
  headerFont: {
    fontSize: "1.1rem",
    fontFamily: "sans-serif",
    fontWeight: 500,
    lineHeight: 1.6,
    letterSpacing: "0.0075em",
  },
}));

function Order() {
  const classes = useStyles();
  const [query, setQuery] = useState({ page: 1, perPage: 100, name: "" });
  const orderStatus = ["in_process", "delivered", "close"];
  const orderItemStatus = [
    "in_process",
    "recieved",
    "recieve",
    "requested",
    "out-for-pickup",
    "delivered",
  ];

  // ******************* Redux State********************************
  const dispatch = useDispatch();
  const { orders, pagination, loading, error } = useSelector((state) => state.getOrders);

  useEffect(() => {
    dispatch(GetOrderAction(query.page, query.perPage, query.name));
  }, [dispatch, query]);

  const retry = () => dispatch(GetOrderAction(query.page, query.perPage, query.name));
  const handleSearch = (name) => {
    setQuery((current) => ({ ...current, page: 1, name: name.trim() }));
  };
  const changeOrderStatusClick = (orderId, status) => {
    dispatch(UpdateOrderStatus({ orderId, status }));
  };
  const changeOrderItemStatusClick = (orderId, statusToChange, status) => {
    dispatch(UpdateOrderItemStatus({ orderId, statusToChange, status }));
  };

  const OrderTable = [
    { id: "invoiceNo", label: "Invoice No", minWidth: 10 },
    { id: "name", label: "Name", minWidth: 10 },
    { id: "email", label: "Email", minWidth: 10 },
    { id: "dateOfMove", label: "Move Date", minWidth: 10 },
    { id: "timeOfMove", label: "Shift", minWidth: 10 },
    { id: "isDrafted", label: "Drafted", minWidth: 10 },
    { id: "createdAt", label: "created", minWidth: 10 },
    { id: "actionBookUser", label: "Is Booked", minWidth: 10 },
    { id: "actionConfirmOrder", label: "Is Confirmed", minWidth: 10 },
    // { id: "actionOrderStatus", label: "Action", minWidth: 140 },
  ];

  return (
    <Grid item container>
      <BreadCrum />
      <OrderSearch
        label="Search by Name, Email"
        handleSearch={handleSearch}
        reset={() => handleSearch("")}
      />
      <Grid
        item
        container
        component={Paper}
        elevation={0}
        className={classes.root}
      >
        <Typography className={classes.headerFont}>Order List</Typography>
        <Grid item container style={{ marginTop: "1rem" }}>
          <TableCollapsible
            tableHead={OrderTable}
            tableData={orders}
            Page={query.page}
            setPage={(page) => setQuery((current) => ({ ...current, page }))}
            Limit={query.perPage}
            setLimit={(perPage) => setQuery((current) => ({ ...current, page: 1, perPage }))}
            total={pagination.total}
            loading={loading}
            error={error}
            onRetry={retry}
            orderStatus={orderStatus}
            changeOrderStatusClick={changeOrderStatusClick}
            changeOrderItemStatusClick={changeOrderItemStatusClick}
            orderItemStatus={orderItemStatus}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Order;
